import React, { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { useApp } from "@/contexts/AppContext";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Upload, Trash2 } from "lucide-react";

const LEGAL = [["legal_nusuk", "legal_nusuk"], ["legal_cr", "legal_cr"], ["legal_license", "legal_license"], ["founded_year", "founded"]];

export default function AboutAdmin({ s, setS }) {
  const { t } = useApp();
  const ref = useRef();
  const [gallery, setGallery] = useState([]);
  const [caption, setCaption] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/public/gallery").then((r) => setGallery(r.data.items));
  useEffect(() => { load(); }, []);
  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData(); fd.append("file", file); fd.append("caption", caption); setBusy(true);
    try { await api.post("/gallery", fd); toast.success(t("saved")); setCaption(""); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || t("failed")); } finally { setBusy(false); }
  };
  const del = async (id) => { if (window.confirm(t("delete") + "?")) { await api.delete(`/gallery/${id}`); load(); } };
  return (
    <div className="space-y-4">
      <Card><CardContent className="p-6 space-y-3">
        <div><Label>{t("about_text")}</Label><Textarea rows={5} value={s.about_text || ""} onChange={(e) => setS({ ...s, about_text: e.target.value })} data-testid="set-about_text" /></div>
        <div className="grid md:grid-cols-2 gap-3">
          {LEGAL.map(([k, lk]) => <div key={k}><Label>{t(lk)}</Label><Input value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} data-testid={`set-${k}`} /></div>)}
        </div>
        <p className="text-xs text-slate-500">{t("about_save_hint")}</p>
      </CardContent></Card>
      <Card><CardContent className="p-6 space-y-3">
        <div className="font-semibold">{t("gallery")} ({gallery.length})</div>
        <div className="flex flex-wrap gap-2 items-end">
          <div className="flex-1 min-w-48"><Label>{t("caption")}</Label><Input value={caption} onChange={(e) => setCaption(e.target.value)} data-testid="gal-caption" /></div>
          <Button disabled={busy} onClick={() => ref.current.click()} className="bg-emerald-600 hover:bg-emerald-700" data-testid="gal-upload-btn"><Upload className="w-4 h-4 mr-2" />{busy ? "..." : t("upload_photo")}</Button>
          <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={(e) => { upload(e.target.files[0]); e.target.value = ""; }} data-testid="gal-file-input" />
        </div>
        <div className="grid sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {gallery.map((g) => (
            <div key={g.id} className="relative group rounded-xl overflow-hidden border" data-testid={`gal-item-${g.id}`}>
              <img src={g.url} alt={g.caption} className="w-full h-32 object-cover" />
              <Button size="sm" variant="destructive" className="absolute top-1 right-1 h-7 w-7 p-0" onClick={() => del(g.id)} data-testid={`gal-del-${g.id}`}><Trash2 className="w-3 h-3" /></Button>
              {g.caption && <div className="text-xs p-1 truncate">{g.caption}</div>}
            </div>))}
        </div>
      </CardContent></Card>
    </div>
  );
}
